var React = require('react');

function DeleteIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 3H12V1C12 0.734784 11.8946 0.48043 11.7071 0.292893C11.5196 0.105357 11.2652 0 11 0H5C4.73478 0 4.48043 0.105357 4.29289 0.292893C4.10536 0.48043 4 0.734784 4 1V3H1C0.734784 3 0.48043 3.10536 0.292893 3.29289C0.105357 3.48043 0 3.73478 0 4C0 4.26522 0.105357 4.51957 0.292893 4.70711C0.48043 4.89464 0.734784 5 1 5H15C15.2652 5 15.5196 4.89464 15.7071 4.70711C15.8946 4.51957 16 4.26522 16 4C16 3.73478 15.8946 3.48043 15.7071 3.29289C15.5196 3.10536 15.2652 3 15 3ZM6 3V2H10V3H6ZM2 6H14V16C14 16.5304 13.7893 17.0391 13.4142 17.4142C13.0391 17.7893 12.5304 18 12 18H4C3.46957 18 2.96086 17.7893 2.58579 17.4142C2.21071 17.0391 2 16.5304 2 16V6Z","fill":"white"}));
}

DeleteIcon.defaultProps = {"width":"16","height":"18","viewBox":"0 0 16 18","fill":"none"};

module.exports = DeleteIcon;

DeleteIcon.default = DeleteIcon;



//////////////////
// WEBPACK FOOTER
// /node_modules/svg-react-loader/lib/loader.js?name=DeleteIcon!./components/modals/assets/delete.svg
// module id = d+ik
// module chunks = 0